import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import FloatingHearts from '../ui/FloatingHearts';

const Layout = () => {
  const { pathname } = useLocation();
  const isMedical = pathname === '/medical';

  return (
  <div className="min-h-screen relative"
    style={{ background:'linear-gradient(155deg,#FFF6F4 0%,#FDF2F8 35%,#F8F0FF 70%,#FFF6F4 100%)', backgroundAttachment:'fixed' }}>

    {/* Ambient glow — warm dreamy atmosphere */}
    <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ zIndex:0 }}>
      <div style={{ position:'absolute', top:'4%', left:'2%', width:580, height:580, borderRadius:'50%',
        background:'radial-gradient(circle,rgba(246,141,179,0.12) 0%,transparent 68%)', filter:'blur(80px)' }} />
      <div style={{ position:'absolute', top:'35%', right:'-4%', width:640, height:640, borderRadius:'50%',
        background:'radial-gradient(circle,rgba(184,138,248,0.09) 0%,transparent 68%)', filter:'blur(90px)' }} />
      <div style={{ position:'absolute', bottom:'8%', left:'12%', width:440, height:440, borderRadius:'50%',
        background:'radial-gradient(circle,rgba(184,138,248,0.08) 0%,transparent 68%)', filter:'blur(72px)' }} />
      <div style={{ position:'absolute', top:'60%', right:'28%', width:340, height:340, borderRadius:'50%',
        background:'radial-gradient(circle,rgba(246,141,179,0.07) 0%,transparent 68%)', filter:'blur(64px)' }} />
      <div style={{ position:'absolute', top:'20%', left:'45%', width:280, height:280, borderRadius:'50%',
        background:'radial-gradient(circle,rgba(216,194,255,0.08) 0%,transparent 68%)', filter:'blur(56px)' }} />
    </div>

    <Sidebar />
    {!isMedical && <FloatingHearts density="layout" fixed />}
    <Navbar />

    <main className="relative pt-14 pb-24 px-4 lg:ml-64 lg:pb-10 lg:px-10" style={{ zIndex:10 }}>
      <div className="max-w-4xl mx-auto">
        <Outlet />
      </div>
    </main>

    <BottomNav />
  </div>
  );
};

export default Layout;
